// extracted by mini-css-extract-plugin
export default {"dashboardWrapper":"adminDashboard_dashboardWrapper__wtF+h","mainWrapper":"adminDashboard_mainWrapper__xSnj3"};